import { LockKeyhole } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function AuthGate({ children, title = 'Login required' }: { children: React.ReactNode; title?: string }) {
  const { loading, user } = useAuth();
  if (loading) return <div className="state-panel">Checking session...</div>;
  if (user) return <>{children}</>;

  return (
    <section className="auth-gate">
      <LockKeyhole size={26} aria-hidden="true" />
      <h2>{title}</h2>
      <p>Sign in to save your response and keep your InstaFlix activity attached to your account.</p>
      <Link className="primary-action" to="/login">
        Continue to login
      </Link>
    </section>
  );
}
